// Rock Hall TV Constants
// Centralized configuration for animations, durations, and styling

export const ANIMATION_CONFIG = {
  DUR_KICK: 1.0,
  DUR_SCALE: 0.65,
  DUR_TRAY_OPEN: 0.4,
  DUR_TRAY_CTA: 0.2,
  EASE_KICK: 'power3.inOut',
  EASE_SCALE_UP: 'power2.inOut',
  EASE_SCALE_DOWN: 'power2.inOut',
  CHANNEL_TITLES_DOWN: '100%',
} as const;

// export const BORDER_RADIUS = {
//   CHANNEL: 4,  // REM
//   MODAL: 7,    // REM
// } as const;

export const LENIS_CONFIG = {
  DURATION: 0.5,
  WHEEL_MULTIPLIER: 1.30,
  EASING: (t: number) => 1 - Math.pow(1 - t, 3),
} as const;

export const INTER_OBS_CONFIG = {
  ROOT_MARGIN: '100px',
  THRESHOLD: 0,
} as const;

export const SCROLLTRIGGER_CONFIG = {
  AT_START_THRESHOLD: 0.001,
  REVERSE_SETTLE_TIME_MS: 1000, // Wait time before activating reverse gesture detection
} as const;

export const MODAL_TIMINGS = {
  // Audio fade out when closing modal
  AUDIO_FADE_OUT_DURATION: 300,           // 300ms - smooth but quick
  AUDIO_FADE_OUT_STEPS: 10,               // Number of volume steps for smooth fade

  // Modal exit animations
  MODAL_EXIT_FADE_DURATION: 333,          // 333ms - main modal fade out (slightly longer than audio fade)
  MODAL_EXIT_WITH_TRAY_DURATION: 400,     // 400ms - when tray needs to close first

  // Pause screen transitions (matching WebGL and image fades)
  PAUSE_SCREEN_FADE_OUT_DURATION: 300,    // 300ms - fade out when unpausing
  PAUSE_SCREEN_FADE_OUT_DELAY: 324,       // 324ms - slight delay for smooth transition

  // Content measurement delays
  CONTENT_MEASUREMENT_DELAY: 50,          // 50ms - wait for CSS to apply before measuring
} as const;

export const RESIZE_DEBOUNCE_MS = 250;    // Debounce delay for resize handler - balances responsiveness vs performance

// Channel Layout and Sizing Constants
export const CHANNEL_LAYOUT = {
  // Pre-kick scale for channel animation
  PRE_KICK_SCALE: 0.32,

  // Header movement multiplier for kick animation
  HEADER_MOVE_MULTIPLIER: 0.25,

  // Items per screen for different display types
  ITEMS_PER_SCREEN_DEFAULT: 1.5,
  ITEMS_PER_SCREEN_VERY_WIDE: 2.2,
  ITEMS_PER_SCREEN_WIDE: 1.8,

  // Aspect ratio thresholds
  ASPECT_VERY_WIDE: 2.0,           // 1800x900 and similar
  ASPECT_WIDE: 1.8,                // Moderately wide screens
  WIDE_LANDSCAPE_THRESHOLD: 1.6,   // Wide landscape screens

  // Header buffer percentages for different screen types
  HEADER_BUFFER_MINIMAL: 0,        // Very wide screens (no buffer)
  HEADER_BUFFER_REDUCED: 0.08,     // Wide screens (8%)
  HEADER_BUFFER_STANDARD: 0.15,    // Standard screens (15%)

  // Channel aspect ratios
  ASPECT_PORTRAIT: 9 / 16,   // 9:16 for portrait channels
  ASPECT_LANDSCAPE: 16 / 9,  // 16:9 for landscape channels
} as const;
